<template>
    <TemplatesPage :error-message="getErrorMessage" :loading="false">
        <form>
            <div class="grid">
                <div class="col-12 md:col-6">
                    <div class="field">
                        <label class="required">{{ $t('lang.report_adcompany_export.site') }}</label>
                        <div class="flex column-gap-1">
                            <AdaptersDropdown
                                v-model="$parent.model.protocol"
                                :options="protocols"
                                option-value="value"
                                option-label="value"
                            />
                            <InputText v-model="$parent.model.userDomain" :placeholder="$t('lang.report_adcompany_export.domain_p')" />
                        </div>
                        <small v-if="!$parent.isUserDomainValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_domain') }}
                        </small>
                    </div>
                    <div class="field formgroup">
                        <label>{{ $t('lang.report_adcompany_export.file_type') }}</label>
                        <div class="field-radiobutton">
                            <RadioButton v-model="$parent.model.format" name="format" value="ya_csv" input-id="ya_csv" @click="$parent.model.showContactInfo = false" />
                            <label for="ya_csv">{{ $t('lang.report_adcompany_export.export_ya_csv') }}</label>
                        </div>
                        <div class="field-radiobutton">
                            <RadioButton v-model="$parent.model.format" name="format" value="ya_xlsx_new" input-id="ya_xlsx_new" />
                            <label for="ya_xlsx_new">{{ $t('lang.report_adcompany_export.export_ya_xlsx_new') }}</label>
                        </div>
                    </div>
                    <div class="field">
                        <label for="" class="required">
                            {{ $t('lang.report_adcompany_export.region') }}
                            <HelpInfo link="https://direct.yandex.ru/tooltip.html?id=geotargeting&lang=ru" />
                        </label>
                        <RegionSelect :model="$parent.model"></RegionSelect>
                        <small v-if="!$parent.isRegionValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_region') }}
                        </small>
                    </div>
                    <div class="field" v-if="$parent.isXlsx">
                        <label>
                            {{ $t('lang.report_adcompany_export.label_phone') }}
                            <HelpInfo link="https://direct.yandex.ru/tooltip.html?id=light-provide-address&lang=ru" />
                        </label>
                        <div>
                            <Button
                                @click="$parent.model.showContactInfo = !$parent.model.showContactInfo"
                                :label="getFillButtonLabel"
                                size="small"
                                severity="secondary"
                            />
                        </div>
                    </div>
                    <input type="hidden" v-model="$parent.model.base" />
                </div>
                <div class="col-12 md:col-6">
                    <h3>{{ $t('lang.report_adcompany_export.text_info') }}</h3>
                    <p>{{ $t('lang.report_adcompany_export.text_p1') }}</p>
                    <p>
                        {{ $t('lang.report_adcompany_export.text_p2') }}
                        <a href="https://direct.yandex.ru/commander/" target="_blank">DirectCommander.</a>
                    </p>
                    <p>
                        {{ $t('lang.report_adcompany_export.text_p3') }}
                        <a href="https://direct.yandex.ru/registered/main.pl?cmd=showExportedXlsList&stat_type=campdate" target="_blank">
                            {{ $t('lang.report_adcompany_export.text_p4') }}
                        </a>
                        {{ $t('lang.report_adcompany_export.text_p5') }}
                    </p>
                </div>
            </div>
            <template v-if="$parent.model.showContactInfo">
                <div class="grid">
                    <div class="col-12 md:col-4 field">
                        <label for="labelCountry" class="required">{{ $t('lang.report_adcompany_export.label_country') }}</label>
                        <AdaptersAutoComplete
                            v-model="selectedCountry"
                            :suggestions="suggestionsCountries"
                            optionLabel="name"
                            ref="countryAutocomplete"
                            @complete="changeCountry"
                            @item-select="selectCountry"
                            inputId="labelCountry"
                            forceSelection
                        />
                        <small v-if="!$parent.isCountryValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_country') }}
                        </small>
                    </div>
                    <div class="col-12 md:col-2 field">
                        <label for="countryCode" class="required">{{ $t('lang.report_adcompany_export.country_code') }}</label>
                        <InputText v-model="$parent.model.countryCode" id="countryCode" />
                        <small v-if="!$parent.isCountryCodeValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_country_code') }}
                        </small>
                    </div>
                    <div class="col-12 md:col-4 field">
                        <label for="labelCity" class="required">{{ $t('lang.report_adcompany_export.label_city') }}</label>
                        <AdaptersAutoComplete
                            v-model="selectedCity"
                            :suggestions="suggestionsCities"
                            optionLabel="name"
                            @complete="changeCity"
                            @item-select="selectCity"
                            inputId="labelCity"
                            forceSelection
                        />
                        <small v-if="!$parent.isCityValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_city') }}
                        </small>
                    </div>
                    <div class="col-12 md:col-2 field">
                        <label for="cityCode" class="required">{{ $t('lang.report_adcompany_export.city_code') }}</label>
                        <InputText :model-value="$parent.model.cityCode" id="cityCode" />
                        <small v-if="!$parent.isCityCodeValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_city_code') }}
                        </small>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-6 field">
                        <label for="phone" class="required">{{ $t('lang.report_adcompany_export.phone') }}</label>
                        <InputMask
                            v-model="$parent.model.phone"
                            mask="+7 999 999-99-99"
                            type="tel"
                            id="phone"
                        />
                        <small v-if="!$parent.isPhoneValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_phone') }}
                        </small>
                    </div>
                    <div class="col-12 md:col-6 field">
                        <label for="addPhone">{{ $t('lang.report_adcompany_export.add_phone') }}</label>
                        <InputMask
                            v-model="$parent.model.addPhone"
                            mask="+7 999 999-99-99"
                            type="tel"
                            id="addPhone"
                        />
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-6 field">
                        <label for="companyName" class="required">{{ $t('lang.report_adcompany_export.company_name') }}</label>
                        <InputText v-model="$parent.model.companyName" id="companyName" />
                        <small v-if="!$parent.isCompanyNameValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_company_name') }}
                        </small>
                    </div>
                    <div class="col-12 md:col-6 field">
                        <label for="contactPerson">{{ $t('lang.report_adcompany_export.contact_person') }}</label>
                        <InputText v-model="$parent.model.contactPerson" id="contactPerson" />
                    </div>
                </div>
                <div class="grid">
                    <div class="col field">
                        <label class="required">{{ $t('lang.report_adcompany_export.worktime') }}</label>
                        <WorkTime :model="$parent.model.workTimes"></WorkTime>
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-6 field">
                        <label for="address">{{ $t('lang.report_adcompany_export.address') }}</label>
                        <InputText v-model="$parent.model.address" id="address" />
                    </div>
                    <div class="col-4 md:col-2 field">
                        <label for="house">{{ $t('lang.report_adcompany_export.house') }}</label>
                        <InputText v-model="$parent.model.house" id="house" />
                    </div>
                    <div class="col-4 md:col-2 field">
                        <label for="build">{{ $t('lang.report_adcompany_export.build') }}</label>
                        <InputText v-model="$parent.model.build" id="build" />
                    </div>
                    <div class="col-4 md:col-2 field">
                        <label for="office">{{ $t('lang.report_adcompany_export.office') }}</label>
                        <InputText v-model="$parent.model.office" id="office" />
                    </div>
                </div>
                <div class="grid">
                    <div class="col-12 md:col-6 field">
                        <label for="email">{{ $t('lang.report_adcompany_export.email') }}</label>
                        <InputText v-model="$parent.model.email" id="email" />
                    </div>
                    <div class="col-12 md:col-6 flex column-gap-1">
                        <div class="field">
                            <label for="imClient">{{ $t('lang.report_adcompany_export.im_client') }}</label>
                            <AdaptersDropdown
                                v-model="$parent.model.imClient"
                                :options="dropdownImClient"
                                option-value="value"
                                option-label="caption"
                                :placeholder="$t('lang.report_adcompany_export.im_client_p')"
                                id="imClient"
                            />
                        </div>
                        <div class="field w-full">
                            <label for="imLogin">{{ $t('lang.report_adcompany_export.im_login') }}</label>
                            <InputText v-model="$parent.model.imLogin" id="imLogin" />
                        </div>
                    </div>
                </div>
                <div class="grid">
                    <div class="col field">
                        <TemplatesLabelCounts
                            :text="$t('lang.report_adcompany_export.about')"
                            :count="$parent.aboutCharacters"
                            :limit="$parent.limitAboutLength"
                        />
                        <Textarea v-model="$parent.model.about" :maxlength="$parent.limitAboutLength" :rows="6" />
                    </div>
                </div>
                <div class="grid">
                    <div class="col field">
                        <label for="ogrn">{{ $t('lang.report_adcompany_export.ogrn') }}</label>
                        <InputText v-model="$parent.model.ogrn" id="ogrn" />
                        <small v-if="!$parent.isOgrnValid" class="error">
                            {{ $t('lang.report_adcompany_export.error_ogrn') }}
                        </small>
                    </div>
                </div>
            </template>
            <div v-if="$parent.model.showAddOptions" class="grid">
                <div class="col field">
                    <label for="groupLimit">
                        {{ $t('lang.report_adcompany_export.group_limit') }}
                        <HelpInfo :text="$t('lang.report_adcompany_export.group_limit_help')" />
                    </label>
                    <InputNumber v-model="$parent.model.groupLimit" :min="1" input-id="groupLimit" />
                </div>
            </div>
            <div class="grid mb-3">
                <div class="col">
                    <Button :label="$t('lang.report_adcompany_export.download')" @click="$parent.download" />
                </div>
            </div>
        </form>
    </TemplatesPage>
</template>

<script>
import TemplatesPage from "../../../templates/Page.vue";
import AdaptersDropdown from "../../../component/adapters/Dropdown.vue";
import InputText from "primevue/inputtext";
import RadioButton from "primevue/radiobutton";
import Button from "primevue/button";
import RegionSelect from "./RegionSelect.vue";
import HelpInfo from "../../../component/adapters/HelpInfo.vue";
import AdaptersAutoComplete from "../../../component/adapters/AutoComplete.vue";
import InputMask from "primevue/inputmask";
import WorkTime from "./WorkTime.vue";
import TemplatesLabelCounts from "../../../templates/LabelCounts.vue";
import Textarea from "primevue/textarea";
import InputNumber from "primevue/inputnumber";

export default {
    name: "AdCompanyExport",
    data() {
        return {
            protocols: [
                {value: 'http://'},
                {value: 'https://'},
            ],
            activeProtocol: 'http://',
            selectedCountry: '',
            selectedCity: '',
            dropdownImClient: [
                {caption: 'ICQ', value: 'icq'},
                {caption: 'Jabber/GTalk', value: 'jabber'},
                {caption: 'Skype', value: 'skype'},
                {caption: 'Mail.ru Агент', value: 'mail_agent'},
            ],
            suggestionsCountries: null,
            suggestionsCities: null,
        };
    },
    props: {
        error: {
            type: String,
            required: false,
            default: null,
        },
        isDemo: {
            type: Boolean,
            required: true,
        },
    },
    computed: {
        getErrorMessage() {
            return this.error ? this.error : this.isDemo ? this.$t('lang.report_adcompany_export.text_demo') : null;
        },
        getFillButtonLabel() {
            return this.$parent.model.showContactInfo
                ? this.$t('lang.report_adcompany_export.button_close')
                : this.$t('lang.report_adcompany_export.button_fill');
        },
        getCountries() {
            return this.$parent.getCountries;
        },
        getCities() {
            return this.$parent.getCities;
        }
    },
    methods: {
        changeCountry(e) {
            let query = e.query;
            let _filteredItems = [];

            for (let i = 0; i < this.getCountries.length; i++) {
                let item = this.getCountries[i];

                if (item.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                    _filteredItems.push(item);
                }
            }

            this.suggestionsCountries = _filteredItems;
        },
        changeCity(e) {
            let query = e.query;
            let _filteredItems = [];

            for (let i = 0; i < this.getCities.length; i++) {
                let item = this.getCities[i];

                if (item.name.toLowerCase().indexOf(query.toLowerCase()) === 0) {
                    _filteredItems.push(item);
                }
            }

            this.suggestionsCities = _filteredItems;
        },
        selectCountry(e) {
            this.$parent.setCountry(e.value);
        },
        selectCity(e) {
            this.$parent.setCity(e, e.value);
        }
    },
    components: {
        TemplatesPage,
        AdaptersDropdown,
        InputText,
        RadioButton,
        Button,
        RegionSelect,
        HelpInfo,
        AdaptersAutoComplete,
        InputMask,
        WorkTime,
        TemplatesLabelCounts,
        Textarea,
        InputNumber,
    }
}
</script>
